import { Box, Tooltip } from "@mui/material";
import { Badge } from "@vds/badges";
import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import { Button } from "@vds/buttons";
import { ButtonIcon } from "@vds/button-icons";
import { Icon } from "@vds/icons";
import { Line } from "@vds/lines";
import { Loader } from "@vds/loaders";
import { Modal, ModalBody, ModalFooter } from "@vds/modals";
import { Notification } from "@vds/notifications";
import { Toggle } from "@vds/toggles";
import { Body, Title } from "@vds/typography";
import { useEffect, useState } from "react";
import { useWindowSize } from "../../global/hooks/viewportHooks";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ImageDownloadMedia } from "../..//model/mediaService";
import { LightText } from "../../features/camerOnboarding/discoveredCameraOnboarding/styles";
import "../BulkRule/bulkrule.css";
import { updateDeployRoi } from "../../api/RoiServiceManager";
import { fetchNotificationGroupsEndPoint, fetchVisionRulesEndPoint } from "../../configuration";
import axiosInstance from "../../global/axiosInterceptor";
import UniqueNameInput from "../../global/components/UniqueNameInput";
import {
  CVAPP_PARKINGOCCUPANCYEE,
  CVAPP_PARKINGOCCUPANCYOA,
  CVAPP_PERSON_DETECTION,
  CVAPP_PROXIMITY,
  CVAPP_VEHICLE_DETECTION,
  CV_APP_TYPE_EVENT
} from "../../global/constants/cvappConstants";
import {
  convertToIsoFormat,
  fetchCameraCVApps,
  formatTimeFrame,
  formatTimeToBrowserTime,
  formatToTimeFrame,
  getCompanionidbyCamera,
  getFovSnapshot,
  getFullCVAppName,
  getLocationByCamera,
  getLocationByTag,
  getParkingCountValue,
  getPriorityColor,
  getROIDatabyRoiID,
  getRoiParentdeviceId,
  getTimeAbbreviation,
  getTimeUnit
} from "../../global/utility/Utils";
import {
  buildDeviceIdExpression,
  getAlertEventInfo,
  getCustomerMessage,
  getcvAppDetails,
  getcvAppImage,
  getcvAppTemplateValue,
  getCvAppTitle,
  getCVAppType,
  getLocationHierarchyWithIds,
  isEntryExitApp
} from "../../global/utility/cvAppUtils";
import { hasPermission } from "../../global/utility/permissionUtils";
import { transformPolygonData } from "../../global/utility/roiUtils";
import { deleteRule, enabledisableRule, updateRule } from "../../model/ruleService";
import DisplayCanvas from "../../polygonLib/displayPolygonLib/displayCanvas";
import {
  fetchCountryIdsRequest,
  fetchRulesByDeviceIdRequest,
  fetchRulesByDeviceIdSuccess,
  fetchRulesListRequest,
  getAllRoiListWithCvApps,
  resetAllRule,
  showNotificationBanner,
  successCreateRule,
  updateRuleValue
} from "../../store/actions";
import SetTrigger from "../BulkRule/CreateRule/SetTrigger";
import RoiImage from "../BulkRule/RoiImage";
import { AlertFlexBox, Container, GreySmallText, GreyText, InputHeaderTitle, Section, SmallText } from "../Rules/Rulesstyle";

const RuleDetails = ({ ruleListInRoi, roiid, videoSource, editRoiTagid, setRuleDetails }) => {
  const { activeSession } = useSelector((state) => state.sessionReducer.activeSession);
  // const { triggerActions: { customData: { selectedDays } } } = useSelector((state) => state.ruleReducer);
  const {
    ruleName,
    appSelected,
    roiSelected,
    triggerActions,
    triggerActions: {
      severity,
      sms,
      email,
      timeFrame,
      triggerData,
      customData: { selectedDays, startTime, endTime, overNightText, timeZone }
    },
    colorsSelected,
    is_color_exclusion_set,
    enableColorAppearance,
    captureVideoEvidence
  } = useSelector((state) => state.ruleReducer);
  const { state } = useLocation();
  const navigate = useNavigate();
  const pairedImages = useSelector((state) => state.imagesReducer.streamImages) || [];
  const roiList = useSelector((state) => state.deviceReducer.roiList) || [];
  const { cameraList, fovList } = useSelector((state) => state?.deviceReducer);
  const tagAllLists = useSelector((state) => state?.sitesReducer.tagIdList);
  const sitesTagList = useSelector((state) => state.sitesReducer.siteTagList);
  const cvAppList = useSelector((state) => state.cvAppReducer.cvAppList) || [];
  const ruleList = state?.record;
  const roiData = getROIDatabyRoiID(roiList, ruleList?.deviceid);
  const roiPolygon = transformPolygonData(roiData);
  const imageSize = { width: 168.23, height: 108 };
  const [modalOpen, setModalOpen] = useState(false);
  const [showNotify, setShowNotify] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [groupList, setGroupList] = useState([]);
  const [toggle, setToggle] = useState(!ruleList?.disabled);
  const [toggleVideoEvidenceCaptureModal, setToggleVideoEvidenceCaptureModal] = useState(false);
  const [isVideoEvidenceCapture, setIsVideoEvidenceCapture] = useState(ruleListInRoi?.captureVideoEvidence ?? true);
  const [toggleLoading, setToggleLoading] = useState(false);
  const selectedState = { showNotification: true };
  const updatedState = { showUpdate: true };
  const { width } = useWindowSize();
  const [isEditing, setIsEditing] = useState(false);
  const dispatch = useDispatch();
  const [rulesList, setRulesList] = useState(ruleList);
  const [imageLoader, setImageLoader] = useState(false);
  const [floorImage, setFloorImage] = useState(null);
  const [isParking, setIsParking] = useState(false);
  const imageSource = videoSource ? videoSource : floorImage ? floorImage : "./assets/sample.png";
  const [fovid, setFovid] = useState("");
  const formatTimeFromTimeStamp = (timestamp) => {
    const newDt = new Date(timestamp);
    const timeStr = newDt.toLocaleTimeString("en-us", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      timeZone: "UTC"
    });

    return timeStr;
  };
  const [isColorTampered, setIsColorTampered] = useState(false);
  const [initialColors, setInitialColors] = useState([]);
  const [initialColorSetFlag, setInitialColorSetFlag] = useState(false);
  const [initialEnableColorAppearanceFlag, setIntitialEnableColorAppearanceFlag] = useState(true);
  const [commonIds, setCommonIds] = useState([]);
  const [deviceIds, setDeviceIds] = useState([]);
  const [foreignIds, setForeignIds] = useState([]);
  const [depId, setDepId] = useState("");
  const [isError, setIsError] = useState(false);
  const [isValidAlertName, setIsValidAlertName] = useState(true);
  const [disableSaveButton, setDisableSaveButton] = useState(false);
  const [isInitial, setIsInitial] = useState(true);
  const headingClassName = `rule-heading ${isError ? "editing" : "not-editing"}`;
  const [selectedLocationTag, setSelectedLocationTag] = useState({
    name: "",
    id: ""
  });
  const alertList = useSelector((state) => state.polygonRoiReducer.rulesByDeviceId) || [];
  const rulesLists = useSelector((state) => state.polygonRoiReducer.rulesData) || [];
  const cachedRulesList = useSelector((state) => state.alertsListReducer.rules) || [];
  const fetched = useSelector((state) => state.polygonRoiReducer.fetched);
  const [fetchRuleInvoked, setFetchRuleInvoked] = useState(false);
  useEffect(() => {
    if (!fetched && !alertList.length) {
      dispatch(fetchRulesByDeviceIdRequest());
    }
  }, [dispatch, fetched]);
  const getRoiList = (commonids, deviceids, foreignids) => {
    setCommonIds(commonids);
    setDeviceIds(deviceids);
    setForeignIds(foreignids);
  };
  const cvAppType = getCVAppType(cvAppList, rulesList?.serviceid ? rulesList?.serviceid : appSelected?.id);
  const dispatchWithPromise = () => {
    return new Promise((resolve) => {
      dispatch(fetchCountryIdsRequest(resolve));
    });
  };
  useEffect(() => {
    if (!sitesTagList || !tagAllLists) {
      dispatchWithPromise().then(() => { });
    }
  }, [tagAllLists, sitesTagList]);

  const getTagLocation = () => {
    const updatedTagId =
      cvAppType === CV_APP_TYPE_EVENT && !editRoiTagid
        ? Array.isArray(rulesList?.tagid)
          ? rulesList?.tagid[0]
          : rulesList?.tagid
        : editRoiTagid && cvAppType !== CV_APP_TYPE_EVENT
          ? Array.isArray(editRoiTagid)
            ? editRoiTagid[0]
            : editRoiTagid
          : Array.isArray(rulesList?.tagid)
            ? rulesList?.tagid[0]
            : rulesList?.tagid
              ? ruleList?.tagid
              : getLocationByCamera(rulesList?.cameraId, cameraList)?.areaId;
    const location = getLocationByTag(tagAllLists, Array.isArray(updatedTagId) ? updatedTagId[0] : updatedTagId);
    setSelectedLocationTag({
      name: location?.name,
      id: location?.id
    });
  };

  // fetch values & updtae redux for rule initially
  useEffect(() => {
    resetRuleData(ruleList);
    setIsVideoEvidenceCapture(ruleList?.captureVideoEvidence ?? true);
    getTagLocation();
  }, [ruleList, ruleListInRoi]);

  useEffect(() => {
    if (ruleListInRoi) {
      sortAndSetRuleData([ruleListInRoi]);
    }
  }, [ruleListInRoi, ruleList, roiid]);

  // reset to initial state for create rule
  useEffect(() => {
    return () => {
      dispatch(resetAllRule());
    };
  }, [dispatch]);

  const updateRuleName = (e) => {
    dispatch(updateRuleValue({ propName: "ruleName", value: e.target.value }));
    setIsInitial(false);
  };

  const getFovId = () => {
    const fovObject = fovList?.find((fov) => fov?.id === getRoiParentdeviceId(roiList, ruleList?.deviceid));
    if (!fovObject) {
      return "NA";
    }
    setFovid(fovObject?.id);
  };

  useEffect(() => {
    getFovId();
  }, [ruleListInRoi]);

  const result = getcvAppTemplateValue(cvAppList, appSelected?.id ? appSelected?.id : ruleList?.serviceid);

  useEffect(() => {
    const appName = getFullCVAppName(rulesList?.serviceid ? rulesList?.serviceid : appSelected?.id, cvAppList);
    if (appName === CVAPP_PARKINGOCCUPANCYEE || appName === CVAPP_PARKINGOCCUPANCYOA) {
      setIsParking(true);
    } else {
      setIsParking(false);
    }
  }, [appSelected, rulesList]);

  const sortAndSetRuleData = (rules) => {
    const updatedRuleList = rules?.map((rule) => {
      const cameraInfo = getLocationByCamera(rule?.cameraId, cameraList);
      const roiData = getROIDatabyRoiID(roiList, rule?.deviceid);
      const roiPolygon = transformPolygonData(roiData);
      // console.log(cameraInfo, roiData, roiPolygon, "roi rule 20 >>>>");
      return {
        ...rule,
        site: cameraInfo?.site,
        area: cameraInfo?.area,
        floor: cameraInfo?.floor,
        cameraName: cameraInfo?.cameraName,
        roiData: roiData,
        roiPolygon: roiPolygon
      };
    });
    let sortedRuleList = updatedRuleList?.sort((b, a) => new Date(a.createdon).getTime() - new Date(b.createdon).getTime());
    // console.log(sortedRuleList, "sortedRuleList >>>")
    resetRuleData(sortedRuleList[0]);
    setRulesList(sortedRuleList[0]);
    // sessionStorage.setItem("ruleList",(JSON.stringify(sortedRuleList)));
  };
  const resetRuleData = (ruleData) => {
    const timeFrame = ruleData?.timeFrame && (ruleData?.timeFrame === "Always active" || ruleData?.TimeFrame === "RB1") ? "RB1" : "RB2";
    const selDaysArr =
      ruleData?.timeFrame &&
      ruleData?.timeFrame !== "NA" &&
      ruleData?.timeFrame !== "Always active" &&
      ruleData?.timeFrame?.length &&
      ruleData?.timeFrame?.map((day) => day.slice(0, 2).toLowerCase());
    const tempSelDays = { ...selectedDays };
    const formattedStartDt = formatTimeToBrowserTime(ruleData?.startTime ? ruleData?.startTime : ruleData?.starttime);
    const formattedEndDt = formatTimeToBrowserTime(ruleData?.endTime ? ruleData?.endTime : ruleData?.endtime);
    const timeParam = formattedStartDt ? "Active between" : "";
    const conditionOperator = ruleData?.condition?.split(" ").slice(-3, -1).join(" ");
    const conditionValue = ruleData?.condition?.split(" ").slice(-1);
    const time = ruleData && ruleData?.duration;
    const groupsValue = ruleData?.contactGroup ? ruleData?.contactGroup : ruleData?.groups ? ruleData?.groups : "";
    let contactGroups = groupsValue;
    if (groupsValue && typeof groupsValue === "string") {
      contactGroups =
        groupsValue &&
        groupsValue?.split(",")?.map((groupLabel) => {
          return { label: groupLabel };
        });
    }

    for (const [day, value] of Object.entries(tempSelDays)) {
      if (selDaysArr?.length && selDaysArr?.includes(day.toLowerCase())) {
        tempSelDays[day] = true;
      }
    }

    dispatch(
      updateRuleValue([
        {
          propName: "triggerActions",
          value: {
            timeFrame: timeFrame,
            severity: ruleData?.severity,
            groups: contactGroups,
            triggerData: {
              condition: conditionOperator,
              value: conditionValue,
              time: getTimeUnit(time),
              addCoolDownPeriod: ruleData?.addCoolDownPeriod,
              coolPeriodValue: ruleData?.addCoolDownPeriod ? ruleData?.coolPeriodValue : 10
            }
          }
        },
        {
          propName: "customData",
          value: {
            selectedDays: tempSelDays,
            startTime: formattedStartDt == "Invalid Date" ? "12:00 AM" : formattedStartDt,
            endTime: formattedEndDt == "Invalid Date" ? "12:30 AM" : formattedEndDt,
            timeParam,
            timeZone: ruleData?.time_zone ? ruleData?.time_zone : "ET",
          }
        },
        {
          propName: "appSelected",
          value: {
            name: getFullCVAppName(ruleData?.serviceid ? ruleData?.serviceid : ruleListInRoi?.cvappid || ruleListInRoi?.cvappId, cvAppList)
          }
        },
        {
          propName: "appSelected",
          value: {
            id: ruleData?.serviceid ? ruleData?.serviceid : ruleListInRoi?.cvappid || ruleListInRoi?.cvappId
          }
        },
        {
          propName: "ruleName",
          value: rulesList?.name ? rulesList?.name : ruleData?.ruleName ? ruleData?.ruleName : ruleData?.name
        }
      ])
    );
  };
  const handleDeleteRule = async () => {
    if (rulesList && rulesList.hasOwnProperty("action")) {
      if (alertList.length > 0) {
        const updatedAlertList = alertList.filter((alert) => alert?.ruleName !== ruleListInRoi?.ruleName);
        dispatch(fetchRulesByDeviceIdSuccess(updatedAlertList));
      }
      setModalOpen(false);
      if (ruleListInRoi) {
        setRuleDetails(false);
      }
      return;
    }
    try {
      setDeleteLoading(true);
      const resp = await deleteRule(activeSession, rulesList?.id);
      if (!ruleListInRoi == true && (resp?.status == 200 || resp?.status == 204)) {
        navigate("/alerts", { state: selectedState });
      } else {
        if (resp?.status !== 200 && resp?.status !== 204) {
          dispatch(
            showNotificationBanner({
              type: "Alert Delete Fail",
              priority: "critical",
              showNotification: true
            })
          );
        } else {
          if (!ruleListInRoi == true && (resp?.status == 200 || resp?.status == 204)) {
            navigate("/alerts", { state: selectedState });
          } else {
            dispatch(successCreateRule([{ update: "delete" }]));
            if (alertList.length > 0) {
              const updatedAlertList = alertList.filter((alert) => (alert?.serviceid !== ruleListInRoi?.serviceid) || (alert?.id !== ruleListInRoi?.id));
              dispatch(fetchRulesByDeviceIdSuccess(updatedAlertList));
            }
            //refershRules();
          }
        }
      }
    } catch (error) {
      console.log("Getting following error", error);
      setShowNotify(!showNotify);
    }
    setDeleteLoading(false);
    setModalOpen(false);
  };
  const refershRules = () => {
    const rulePayload = {
      accountname: activeSession?.accountId,
      filter: {
        $selection: {
          deviceid: rulesList?.deviceid ? rulesList?.deviceid : roiSelected[0]?.id
        }
      }
    };
    dispatch(fetchRulesByDeviceIdRequest(rulePayload));
  };
  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const fetchNotificationGroups = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.post(fetchNotificationGroupsEndPoint(), {
        accountname: activeSession.accountId
      });
      const groupNames = rulesList?.groups
        ? rulesList?.groups?.split(",")?.map((name) => name.trim())
        : rulesList?.contactGroup?.split(",")?.map((name) => name.trim());
      const matchingGroups = res?.data?.filter((group) => groupNames?.includes(group?.name));

      const processedGroups = matchingGroups?.map((group) => {
        const allUsers = group?.users?.map((user) => `${user?.firstname} ${user?.lastname}`);
        const displayedUsers = allUsers?.slice(0, 4);
        return {
          ...group,
          displayedUsers,
          allUsers,
          hasMoreUsers: group?.users?.length > 4
        };
      });
      setGroupList(processedGroups);
    } catch (error) {
      console.error("Failed to fetch notification groups", error);
    } finally {
      setLoading(false);
    }
  };

  const toggleRule = async (e) => {
    try {
      setToggleLoading(true);
      await enabledisableRule(activeSession, rulesList?.id, toggle);
      fetchRules();
    } catch (error) {
      console.log("Getting error while trying to toggle", error);
      setToggle(toggle);
      const notificationInfo = {
        type: "Update Alert Fail",
        priority: "critical",
        showNotification: true
      };
      dispatch(showNotificationBanner(notificationInfo));
    } finally {
      dispatch(fetchRulesListRequest());
      setToggleLoading(false);
    }
  };

  const fetchRules = async () => {
    if (rulesList?.id) {
      try {
        setFetchRuleInvoked(true);
        const cachedRule = cachedRulesList?.find((rule) => rule?.id === rulesList?.id);
        if (cachedRule) {
          return;
        }
        const accountId = activeSession.accountId;
        const requestBody = {
          accountname: accountId,
          filter: {
            $selection: {
              id: rulesList?.id
            }
          }
        };
        const response = await axiosInstance.post(fetchVisionRulesEndPoint(), requestBody);
        const fetchedRules = response.data;
        setToggle(!fetchedRules[0]?.disabled);
      } catch (e) {
        console.error("Getting error while trying to fetch alerts", e);
        return;
      } finally {
        setToggleLoading(false);
        setFetchRuleInvoked(false);
      }
    }
  };

  const handleCancel = () => {
    setIsInitial(true);
    setIsValidAlertName(true);
    setIsError(false);
    dispatch(
      updateRuleValue([
        {
          propName: "ruleName",
          value: rulesList?.name || ruleListInRoi?.ruleName
        },
        {
          propName: "triggerActions",
          value: {
            timeFrame: rulesList?.showTimeFrame == true ? "RB2" : "RB1"
          }
        }
      ])
    );
    setTimeout(() => {
      setIsEditing(false);
    }, [100]);
  };

  useEffect(() => {
    // Only fetch data if we have a rule with an ID (existing rule) or ruleListInRoi (new/editing rule in ROI context)
    if (rulesList?.id) {
      fetchNotificationGroups();
      setToggleLoading(true);
      fetchRules();
    } else if (ruleListInRoi) {
      fetchNotificationGroups();
    }
  }, [rulesList?.id, ruleListInRoi]);

  useEffect(() => {
    if (
      !isValidAlertName ||
      ruleName?.length == "" ||
      triggerData?.value == "" ||
      triggerData?.condition == "" ||
      severity == "" ||
      triggerData?.isError == true ||
      ((rulesList?.addUnits === true || ruleListInRoi?.addUnits === true) && triggerData?.time == "")
    ) {
      setDisableSaveButton(true);
    } else {
      setDisableSaveButton(false);
    }
  }, [triggerData, isValidAlertName, ruleName, severity, setIsValidAlertName]);

  const payload = {
    accountname: activeSession?.accountId,
    resourceidentifier: {
      id: rulesList?.deploymentid ? rulesList?.deploymentid : ruleListInRoi?.deploymentid
    }
  };

  const fetchFloorImage = async () => {
    try {
      setImageLoader(true);
      const pairedImage = pairedImages && pairedImages.find((img) => (img?.id === rulesList?.fovid ? ruleList?.fovid : ruleListInRoi?.fovid));
      if (pairedImage) {
        const imgUrl = pairedImage?.imageUrl;
        setFloorImage(imgUrl);
      } else {
        const imgUrl = await ImageDownloadMedia(getFovSnapshot(fovList, rulesList?.fovid ? ruleList?.fovid : ruleListInRoi?.fovid), activeSession, "", "snapshot");
        setFloorImage(imgUrl);
      }
    } catch (error) {
      setFloorImage(null);
      console.error("Error downloading image:", error);
    } finally {
      setImageLoader(false);
    }
  };

  useEffect(() => {
    if (
      ruleList?.aggregateRule === false ||
      ruleListInRoi?.aggregateRule === false ||
      isEntryExitApp(cvAppList, ruleList?.serviceid) ||
      isEntryExitApp(cvAppList, ruleListInRoi?.serviceid)
    ) {
      fetchFloorImage();
    }
  }, []);
  const saveEditing = async () => {
    const formattedSelDays = timeFrame == "RB1" ? "Always active" : formatToTimeFrame(selectedDays);
    const showTimeFrame = timeFrame === "RB2"; // RB2 === custom timeframe
    const formattedStartTime = showTimeFrame ? convertToIsoFormat(startTime) : "NA";
    const formattedEndTime = showTimeFrame ? convertToIsoFormat(endTime, overNightText) : "NA";

    try {
      setToggleLoading(true);

      const updatedLocationHierarchy = getLocationHierarchyWithIds(sitesTagList, selectedLocationTag?.id);
      const updatedLocationTag = getLocationByTag(tagAllLists, selectedLocationTag?.id);
      const groups = triggerActions?.groups && triggerActions?.groups?.map((group) => group.label).join(",");
      const payload = {
        activeSession,
        roiId: rulesList?.deviceid ? rulesList?.deviceid : roiSelected[0]?.id,
        cvappId: rulesList?.serviceid ? rulesList?.serviceid : appSelected?.id,
        severity,
        groups,
        cameraId: rulesList?.cameraId,
        ruleId: rulesList?.id,
        ruleName: ruleName,
        selectedDays: formattedSelDays,
        showTimeFrame,
        startTime: formattedStartTime,
        endTime: formattedEndTime,
        sms,
        email,
        conditionOperator: triggerData?.condition,
        conditionValue: triggerData?.value,
        cvAppName: rulesList?.appName,
        expression: getcvAppDetails(cvAppList, rulesList?.serviceid ? rulesList?.serviceid : appSelected?.id),
        fovid: fovid ? fovid : rulesList?.fovid,
        companionid: getCompanionidbyCamera(cameraList, rulesList?.cameraId),
        deploymentid: rulesList?.deploymentid !== "NA" ? rulesList?.deploymentid : depId,
        cvappImage: getcvAppImage(cvAppList, rulesList?.serviceid ? rulesList?.serviceid : appSelected?.id),
        customerMessage: getCustomerMessage(cvAppList, rulesList?.serviceid ? rulesList?.serviceid : appSelected?.id),
        title: getCvAppTitle(cvAppList, rulesList?.serviceid ? rulesList?.serviceid : appSelected?.id),
        aggregateRule: rulesList?.aggregateRule ? rulesList?.aggregateRule : false,
        eventinfo: getAlertEventInfo(
          cvAppList,
          rulesList?.serviceid ? rulesList?.serviceid : appSelected?.id,
          updatedLocationTag ? updatedLocationTag?.name : getLocationByCamera(rulesList?.cameraId, cameraList)?.area,
          triggerData?.value,
          triggerData?.condition,
          triggerData?.time ? `${triggerData?.value}${getTimeAbbreviation(triggerData?.time)}` : ruleListInRoi?.duration || rulesList?.duration
        ),
        EEAppName: rulesList?.EEAppName ? rulesList?.EEAppName : ruleListInRoi?.EEAppName || "",
        addUnits: rulesList?.addUnits ? rulesList?.addUnits : ruleListInRoi?.addUnits || false,
        triggerData: triggerData,
        addCoolDownPeriod: triggerData?.addCoolDownPeriod,
        coolPeriodValue: triggerData?.addCoolDownPeriod == true ? triggerData?.coolPeriodValue : "",
        isParking: isParking,
        tagid: updatedLocationTag?.id ? updatedLocationTag?.id : getLocationByCamera(rulesList?.cameraId, cameraList)?.areaId,
        location: updatedLocationHierarchy,
        isEventApp: cvAppType === CV_APP_TYPE_EVENT ? true : false
      };
      if (isParking == true) {
        const numericTriggerValue = Number(triggerData?.value) || 0;
        const defaultValue = getParkingCountValue(tagAllLists, Array.isArray(rulesList?.tagid) ? rulesList?.tagid[0] : rulesList?.tagid);
        const numericParkingOccupancy = Number(defaultValue) || 0;
        payload.result = Math.floor((numericTriggerValue / 100) * numericParkingOccupancy);
      }
      if (ruleList?.aggregateRule === true) {
        payload.deviceIds = deviceIds;
        payload.foreignIds = foreignIds;
        payload.globalExpression = buildDeviceIdExpression(deviceIds);
      }
      if (ruleListInRoi?.addUnits === true || rulesList?.addUnits === true) {
        payload.duration = triggerData?.time
          ? `${triggerData?.value}${getTimeAbbreviation(triggerData?.time)}`
          : ruleListInRoi?.duration || rulesList?.duration;
      }
      payload.isVideoEvidenceCapture = isVideoEvidenceCapture;
      payload.timeZone = timeZone;
      if (!ruleListInRoi) {
        const resp = await updateRule(payload);
        if (resp && (resp[0]?.id || resp?.id)) {
          navigate("/alerts", { state: updatedState });
          dispatch(fetchRulesByDeviceIdRequest());
          dispatch(fetchRulesListRequest());
        }
        if (resp?.status !== 200 && resp?.status !== 204) {
          dispatch(
            showNotificationBanner({
              type: "Update Alert Fail",
              priority: "critical",
              showNotification: true
            })
          );
        }
      } else {
        if (ruleListInRoi && ruleListInRoi.action === "create") {

          const updatedFilterList = alertList.filter((alert) => alert?.ruleName !== ruleListInRoi?.ruleName);
          payload.action = "create";
          payload.triggerData = triggerData;
          payload.showTimeFrame = showTimeFrame;
          payload.timeFrame = formattedSelDays;
          payload.cvAppName = appSelected?.name;
          setTimeout(() => {
            const updatedAlertList = Array.isArray(updatedFilterList) && updatedFilterList.length > 0
              ? [...updatedFilterList, payload]
              : [payload];
            dispatch(fetchRulesByDeviceIdSuccess(updatedAlertList));
          }, 500);
        } else {
          const resp = await updateRule(payload);
          dispatch(successCreateRule([{ update: "edit", updateResponse: resp }]));
          refershRules();
        }
      }
    } catch (error) {
      setIsEditing(false);
      console.log("Getting error", error);
    } finally {
      setToggleLoading(false);
      setIsEditing(false);
      setShowNotify(false);
    }
  };

  const showPermissionsBanner = () => {
    const notificationInfo = {
      type: "No Permission",
      priority: "critical",
      showNotification: true
    };
    dispatch(showNotificationBanner(notificationInfo));
  };

  const getDeploymentid = async () => {
    const deploymentid = !rulesList?.aggregateRule && (await fetchCameraCVApps(roiid ? roiid : rulesList?.deviceid, activeSession, cvAppList));
    if (deploymentid) {
      setDepId(deploymentid[0]?.id || "depId");
    }
  };
  useEffect(() => {
    getDeploymentid();
  }, [roiSelected, ruleListInRoi, roiid]);

  return (
    <>
      {rulesList?.appName === CVAPP_PROXIMITY && triggerData?.isError == true && !isNaN(triggerData?.value) && (
        <Notification
          type="error"
          fullBleed={false}
          title={"Error"}
          subtitle={`The maximum distance that this app is set to detect is ${result?.default}ft. Please lower the number in the condition.`}
          disableFocus={false}
          hideCloseButton={true}
        />
      )}
      {!ruleListInRoi && (
        <Breadcrumbs surface="light">
          <BreadcrumbItem>
            <Link data-testid="ruleDetails_settingsLink" to="/settings" className="breadcrums-item_link">
              Settings
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link data-testid="editRoleTemplate_alertsLink" to="/alerts" className="breadcrums-item_link">
              Alerts
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>Alert details</BreadcrumbItem>
        </Breadcrumbs>
      )}
      <div style={{ marginBottom: "10px" }}></div>
      <Box sx={{ p: 2, width: "100%", padding: "none !important" }}>
        <AlertFlexBox>
          <div
            className={`rule-details-header-row ${isEditing ? "editing" : ""}`}
          >
            {isEditing ? (
              <div className="rule-name-input-wrapper">
                <UniqueNameInput
                  value={ruleName}
                  data-testid="ruleDeatils_uniqueNameInput"
                  onChange={updateRuleName}
                  error={isError}
                  isError={isError}
                  setIsError={setIsError}
                  dataList={[...cachedRulesList, ...rulesLists]}
                  setIsValid={setIsValidAlertName}
                  isEdit={true}
                  isInitial={isInitial}
                />
              </div>
            ) : (
              <Tooltip title={rulesList?.ruleName ? rulesList?.ruleName : rulesList?.name}>
                <div
                  className={`rule-heading ${ruleListInRoi ? 'with-roi' : ''}`}
                >
                  {rulesList?.ruleName ? rulesList?.ruleName : rulesList?.name}
                </div>
              </Tooltip>
            )}
            {rulesList?.action !== "create" && rulesList?.id && (
              <div className={`rule-details-toggle-group ${isEditing ? "editing" : ""}`}>
                <div
                  style={{
                    borderLeft: "1px solid",
                    height: "36px",
                    borderColor: "lightgray",
                    gap:"25px"
                  }}
                />
                {!fetchRuleInvoked && <Toggle
                  on={toggle}
                  surface="light"
                  showText={true}
                  textWeight="regular"
                  textSize="small"
                  textPosition="right"
                  statusText={(e) => (e ? "Alert On" : "Alert Off")}
                  data-testid="ruleDetails_ruleToggle"
                  onChange={(e) => {
                    toggleRule(e);
                    setToggle(!toggle);
                  }}
                />}
               {!fetchRuleInvoked && cvAppType === CV_APP_TYPE_EVENT && <Toggle
                  on={isVideoEvidenceCapture}
                  surface="light"
                  showText={true}
                  textWeight="regular"
                  disabled={!isEditing}
                  textSize="small"
                  textPosition="right"
                  statusText={(e) => (e ? "Capture Video Evidence" : "Capture Video Evidence")}
                  data-testid="ruleDetails_CaptureVideoEvidenceToggle"
                  onChange={(e) => {
                   setToggleVideoEvidenceCaptureModal(true);
                  }}
                />}
                {(toggleLoading || fetchRuleInvoked) ? (
                  <div className="loader-absolute-container">
                    <Loader active={true} fullscreen={false} surface="light" />
                  </div>
                ) : ""}
              </div>
            )}
          </div>

          <div style={{ display: "flex", gap: "12px" }}>
            {!isEditing && (
              <Button
                size={width < 768 ? "small" : "large"}
                use="primary"
                width="auto"
                style={{ alignItem: "right" }}
                data-testid="alerts_editAlertButton"
                onClick={() => {
                  if (!hasPermission("Alerts", "Edit")) {
                    showPermissionsBanner();
                  } else {
                    setIsEditing((prevState) => !prevState);
                    setShowNotify(false);
                  }
                }}
              >
                Edit Alert
              </Button>
            )}
            {isEditing && (
              <Button
                size={width < 768 ? "small" : "large"}
                use="primary"
                width="auto"
                style={{ alignItem: "right" }}
                disabled={disableSaveButton}
                data-testid="alerts_saveEditsButton"
                onClick={() => {
                  if (
                    (appSelected?.name === CVAPP_PERSON_DETECTION || appSelected?.name === CVAPP_VEHICLE_DETECTION) &&
                    isColorTampered &&
                    (ruleListInRoi?.id || rulesList?.id)
                  ) {
                    setToggleLoading(true);
                    isColorTampered &&
                      updateDeployRoi(payload)
                        .then((response) => {
                          setToggleLoading(false);
                          saveEditing();
                          dispatch(getAllRoiListWithCvApps());
                        })
                        .catch((error) => {
                          setToggleLoading(false);
                          dispatch(
                            showNotificationBanner({
                              type: "Update Alert Fail",
                              priority: "critical",
                              showNotification: true
                            })
                          );
                        });
                  } else {
                    saveEditing();
                  }
                }}
              >
                Save edits
              </Button>
            )}
            {isEditing && (
              <Button size={width < 768 ? "small" : "large"} use="secondary" width="auto" style={{ alignItem: "right" }} data-testid="alerts_cancelEditButton" onClick={handleCancel}>
                Cancel edit
              </Button>
            )}
            {!isEditing && (
              <Button
                size={width < 768 ? "small" : "large"}
                use="secondary"
                width="auto"
                style={{ alignItem: "right" }}
                data-testid="alerts_deleteAlertButton"
                onClick={() => {
                  if (!hasPermission("Alerts", "Delete")) {
                    showPermissionsBanner();
                  } else {
                    setModalOpen(true);
                    setShowNotify(false);
                  }
                }}
              >
                Delete Alert
              </Button>
            )}
          </div>
        </AlertFlexBox>
      </Box>
      <br />
      <Container>
        <Section>
           
          <InputHeaderTitle>App</InputHeaderTitle>
          <SmallText>{appSelected?.name ? appSelected?.name : rulesList?.cvAppName ? rulesList?.cvAppName : rulesList?.appName}</SmallText>
        </Section>
        <Section>
          <InputHeaderTitle>Location</InputHeaderTitle>
          <SmallText>{`${rulesList?.area}, ${rulesList?.floor}, ${rulesList?.site}`}</SmallText>
        </Section>
      </Container>
      <br />
      <Line type="secondary" style={{ color: "grey" }} />
      <br />

      <Container>
        <Section>
          <InputHeaderTitle>Regions of Interest</InputHeaderTitle>
          <SmallText>
            {getLocationByTag(tagAllLists, Array.isArray(rulesList?.tagid) ? rulesList?.tagid[0] : rulesList?.tagid)?.name ||
              getLocationByCamera(rulesList?.cameraId || ruleListInRoi?.cameraId, cameraList)?.area}
          </SmallText>
          <div>
            {ruleList?.aggregateRule || isEntryExitApp(cvAppList, ruleList?.serviceid) || isEntryExitApp(cvAppList, ruleListInRoi?.serviceid) ? (
              <RoiImage ruleList={ruleList} activeSession={activeSession} fovList={fovList} getRoiList={getRoiList} cvAppList={cvAppList} />
            ) : (
              <>
                {imageLoader ? (
                    <div className="alert-snapshot-loading">
                      <div className="camera-snapshot-loader-wrapper">
                        <Loader active={true} fullscreen={false} surface="light" />
                      </div>
                    </div>
                ) : !videoSource && !floorImage ? (
                  <div className="alert-snapshot-error">
                    <div className="camera-snapshot-error-content">
                      <Icon name="error" size="small" color="#6f7171" />
                      <LightText>Snapshot failed to load</LightText>
                      <ButtonIcon
                        onClick={() => fetchFloorImage()}
                        renderIcon={() => <Icon name="sync" size="small" />}
                      />
                    </div>
                  </div>
                ) : (
                  ((roiPolygon && roiPolygon.length !== 0) || (rulesList?.roiPolygon && rulesList?.roiPolygon.length !== 0)) && (
                    <DisplayCanvas
                      videoSource={imageSource}
                      imageSize={imageSize}
                      initialPolygons={ruleListInRoi ? rulesList?.roiPolygon : roiPolygon}
                      originalSize={[ruleListInRoi ? rulesList?.roiData : roiData, ruleListInRoi ? rulesList?.roiData : roiData]}
                    />
                  )
                )}
              </>
            )}
          </div>
          <br />
        </Section>
      </Container>

      <Line type="secondary" style={{ color: "grey" }} />
      <br />

      {!isEditing && (
        <div style={{ overflow: "auto", minHeight: "200px" }}>
          <Container>
            <Section>
              <InputHeaderTitle style={{ marginBottom: "20px" }}>Trigger</InputHeaderTitle>
              <div style={{ display: "flex", fontSize: "16px" }}>
                <Icon name="reports-and-alerts" size="20px" color="#A7A7A7" />
                <GreyText bold size="large">
                  Condition:
                </GreyText>
                <Body size="large">
                  {rulesList?.condition?.length
                    ? rulesList?.condition
                    : rulesList?.triggerData?.condition
                      ? cvAppType !== CV_APP_TYPE_EVENT
                        ? `${rulesList?.cvAppName || appSelected?.name} ${rulesList?.triggerData?.condition} ${rulesList?.triggerData?.value}`
                        : `${appSelected?.name} detected`
                      : `${appSelected?.name} detected`}
                </Body>
              </div>
              <br />
              <div style={{ display: "flex", fontSize: "16px" }}>
                <Icon name="clock" size="20px" color="#A7A7A7" />
                <GreyText bold size="large">
                  Timeframe:
                </GreyText>
                <Body size="large">
                  {rulesList?.showTimeFrame === false && (rulesList?.timeFrame === "Always active" || ruleList?.timeFrame?.length == "")
                    ? "Always active"
                    : formatTimeFrame(
                      formatTimeToBrowserTime(rulesList?.startTime ? rulesList?.startTime : rulesList?.starttime),
                      formatTimeToBrowserTime(rulesList?.endTime ? rulesList?.endTime : rulesList?.endtime),
                      rulesList?.timeFrame
                    )}
                </Body>
              </div>
            </Section>
          </Container>

          <br />
          <Line type="secondary" style={{ color: "grey" }} />
          <br />

          <Container>
            <Section>
              <InputHeaderTitle style={{ marginBottom: "20px" }}>Actions</InputHeaderTitle>
              <div style={{ display: "flex", fontSize: "16px" }}>
                <GreyText bold size="large">
                  Severity: &nbsp;
                </GreyText>
                <Body size="large">
                  <Badge fillColor={getPriorityColor(rulesList?.severity)}>{rulesList?.severity ? rulesList?.severity : "NA"}</Badge>
                </Body>
              </div>
            </Section>
          </Container>

          <Container>
            <Section>

              <GreyText>Groups</GreyText>
              {loading ? (
                <GreySmallText>
                  {loading ? "Loading..." : "No matching group"}
                </GreySmallText>
              ) :
                (groupList?.length > 0 ? (
                  groupList?.map((group) => (
                    <div key={group.id}>
                      <Body size="large">{group?.name}</Body>
                      {group?.displayedUsers?.length ? (
                        <Tooltip
                          title={
                            <Body size="medium" color="#FFFFFF">
                              {group?.allUsers.join(", ")}
                            </Body>
                          }
                          arrow
                          placement="top"
                        >
                          <GreySmallText style={{ cursor: "pointer" }}>
                            {group?.displayedUsers?.join(", ")}
                            {group?.hasMoreUsers && " ..."}
                          </GreySmallText>
                        </Tooltip>
                      ) : (
                        <GreySmallText>Not defined</GreySmallText>
                      )}
                    </div>
                  ))
                ) : (
                  <GreySmallText>
                    No matching group
                  </GreySmallText>
                )
                )}
            </Section>
          </Container>
        </div>
      )}

      {isEditing && <SetTrigger isEditing ruleList={rulesList} result={result} />}

      <Modal
        opened={modalOpen}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
        surface="light"
        width="560px"
        fullScreenDialog={false}
        disableAnimation={false}
        disableOutsideClick={true}
        closeButton={
          <div
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "25px",
              top: "25px"
            }}
            data-testid="alerts_closeIcon"
            onClick={handleCloseModal}
          >
            <Icon name="close" />
          </div>
        }
      >
        <br />
        <Notification
          type="warning"
          title="Warning"
          subtitle="If deleted, this alert will no longer generate events or notifications."
          fullBleed={true}
          inline={false}
          disableFocus={true}
        />
        <br />
        <Title size="large" bold>
          Delete Alert
        </Title>
        <ModalBody>Are you sure you’d like to delete this alert?</ModalBody>
        <ModalFooter
          buttonData={{
            primary: {
              width: "100%",
              children: deleteLoading ? "Loading" : "Yes, delete",
              disabled: deleteLoading,
              "data-testid": "alerts_yesDeleteButtonGroup",
              onClick: () => {
                handleDeleteRule();
              }
            },
            close: {
              width: "100%",
              children: "No, cancel",
              "data-testid": "alerts_noCancelButtonGroup",
              onClick: () => handleCloseModal(),
              disabled: deleteLoading
            }
          }}
        />
      </Modal>

       <Modal
        opened={toggleVideoEvidenceCaptureModal}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
        surface="light"
        width="560px"
        fullScreenDialog={false}
        disableAnimation={false}
        disableOutsideClick={true}
        closeButton={
          <div
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "25px",
              top: "25px"
            }}
            data-testid="alerts_closeIcon"
            onClick={() => setToggleVideoEvidenceCaptureModal(false)}
          >
            <Icon name="close" />
          </div>
        }
      >
        <br />
        <Notification
          type="warning"
          title="Warning"
          subtitle="If turned off, this alert will no longer generate video evidence."
          fullBleed={true}
          inline={false}
          disableFocus={true}
        />
        <br />
        <Title size="large" bold>
          Capture Video Evidence Alert
        </Title>
        <ModalBody>Are you sure you do not want to capture the video evidence of event?</ModalBody>
        <ModalFooter
          buttonData={{
            primary: {
              width: "100%",
              children:  "Yes",
              "data-testid": "alerts_yesDeleteButtonGroup",
              onClick: () => {
                setIsVideoEvidenceCapture(!isVideoEvidenceCapture);
                dispatch(updateRuleValue({ propName: "captureVideoEvidence", value: !isVideoEvidenceCapture }));
                setToggleVideoEvidenceCaptureModal(false);
              }
            },
            close: {
              width: "100%",
              children: "Cancel",
              "data-testid": "alerts_noCancelButtonGroup",
              onClick: () => {
                setToggleVideoEvidenceCaptureModal(false);
              },
              disabled: deleteLoading
            }
          }}
        />
      </Modal>
    </>
  );
};

export default RuleDetails;
